import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType,HttpHeaders } from '@angular/common/http';
import { TokenService } from '../../token.service';
import {MainService} from './main.service';
import { MakingDataService } from '../../md/service/making-data.service';
@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  httpUrl;
  constructor(private mds:MakingDataService,private http: HttpClient, private main: MainService, private token:TokenService) {
    this.httpUrl = this.main.httpUrl + '/portal';
  }
  async getImage(user_id:any) {
    const obj:any = new Object();
    obj['user_id'] = user_id;
    const resp = await this.http.post(this.main.httpUrl + '/portal/getprofileimage', obj ,  {   responseType: 'blob' }).toPromise().then(res => {
        return res;
      });
      if (resp) {
        return resp;
    }
    return
  }
  async getAccImage(b_acct_id:any) {
    const obj:any = new Object();
    obj['b_acct_id'] = b_acct_id;
    const resp = await this.http.post(this.httpUrl + '/getAccountImage', obj,  {  responseType: 'blob' }).toPromise().then(res => {
        return res;
      });
      if (resp) {
        return resp;
    }
    return
  }
  async getUserProfileInfo(user_id:any){
    const res = await this.http.get<any>(this.httpUrl + '/getUserInfo'+user_id ).toPromise().then(res => {
      return res;

    });
    return res;
  }
  async getEstablishmentInfo(obj :any) {
    const res = await this.http.get<any>(this.main.httpUrl + '/hr/emp_info/empInfo/getUserInfo'+obj ).toPromise().then(res => {
      return res;

    });
    return res;
  }
  async getPostingInfo(obj :any) {
    const resp = await this.http.get<any>(this.main.httpUrl + '/hr/establishment_info/post/getAllAssignedPosts' + JSON.stringify(obj) ).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async getAllApproval(b_acct_id:any) {
    const resp = await this.http.get<any>(this.main.httpUrl + '/approval/getapproval' + b_acct_id ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async getAllApprovalStatus(obj :any) {
    const resp = await this.http.get<any>(this.main.httpUrl + '/approval/getdataofapprovalstatus' + JSON.stringify(obj) ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async getAccProfileInfo(user_id:any){

    const res = await this.http.get<any>(this.httpUrl + '/getAccountInfo'+user_id ).toPromise().then(res => {
      return res;

    });
    return res;

  }
  async updateProfile(obj :any) {
    const resp = await this.http.put<any>(this.httpUrl + '/updateProfile', obj ).toPromise().then(res => {
      return res;
     });
    return resp;
   }

   async updateAccProfile(obj :any) {
    const resp = await this.http.put<any>(this.httpUrl + '/updateAccountInfo', obj ).toPromise().then(res => {
      return res;
     });
    return resp;
   }
   async changePassword(obj :any) {
    const resp = await this.http.put<any>(this.httpUrl + '/changePassword', obj ).toPromise().then(res => {
      return res;
     });
    return resp;
   }
   //Updated New Api

   async getaccountmodule(obj :any) {
    const resp = await this.http.get<any>(this.main.httpUrl + '/systemdata/legalentity/getaccountmodule',{ headers: new HttpHeaders().append('data',await this.mds.dataE(obj))}).toPromise().then(async res => {
      return await this.mds.dataD(res);
    });
    return resp;
  }
  async updateProfileInfo(obj :any) {
   const resp = await this.http.put<any>(this.main.httpUrl + '/systemdata/legalentity/updateprofile', obj ).toPromise().then(res => {
    return res;
    });
   return resp;
  }
  async updatepassword(obj: any) {
    const payload = await this.mds.dataE(obj);
    const resp = await this.http.post<any>(this.main.httpUrl + '/systemdata/legalentity/updatepassword', { data: payload } ).toPromise().then(res => {
      return this.mds.dataD(res);

    });
    return resp;
  }

  async updatepasswordotp(obj: any) {
    const payload = await this.mds.dataE(obj);
    const resp = await this.http.post<any>(this.main.httpUrl + '/systemdata/legalentity/updatepasswordotp', { data: payload } ).toPromise().then(res => {
      return this.mds.dataD(res);

    });
    return resp;
  }

  async uploadAccountprofile(obj :any) {
  const resp = await this.http.post<any>(this.httpUrl + '/uploadAccountImage',  obj ).toPromise().then(res => {
    return res;
   });
  return resp;
 }
  async uploadUserprofile(obj :any) {
  const resp = await this.http.post<any>(this.httpUrl + '/uploadImage',  obj ).toPromise().then(res => {
    return res;
   });
  return resp;
 }
 async updateACC_info(obj :any) {
 const resp = await this.http.put<any>(this.main.httpUrl + '/systemdata/legalentity/updateaccountinfo', obj ).toPromise().then(res => {
   return res;
  });
 return resp;
}

async getEmpID(obj :any) {
  const resp = await this.http.get<any>(this.main.httpUrl + '/md/resource/getempidbyuserid'+obj ).toPromise().then(res => {
    return res;
  });
  return resp;
}

async getUserDetailsForProfile(obj :any) {
  const resp = await this.http.get<any>(this.main.httpUrl + '/md/user/getUserDetailsForProfile'+obj ).toPromise().then(res => {
    return res;
  });
  return resp;
}
async UpdateuserProfileDetails(obj :any) {
  const payload = await this.mds.dataE(obj);
  const resp = await this.http.put<any>(this.main.httpUrl + '/md/user/UpdateuserProfileDetails', { data: payload }).toPromise().then(res => {
    return res;
  });
  return resp;
}



}
